<template>
  <div class="login-page">
    <HeaderView />
    <div v-if="auth_token == ''" class="login-shell" :class="{
      'bg-content': $store.state.screenWidth > 375,
      'bg-content-se': $store.state.screenWidth <= 375,
      'bg-content-4': $store.state.screenWidth <= 320
    }">
      <div class="login-layout">
        <section class="login-visual" aria-hidden="true">
          <div class="login-brand">
            <img src="/static/img/logo/open-house-2026.png" alt="RMUTL Open House 2026" />
            <div>
              <span>RMUTL</span>
              <strong>OPEN HOUSE</strong>
            </div>
          </div>
          <div class="tech-orbit">
            <div class="tech-core">
              <img src="/static/img/mascot/rmutl-laptop.png" alt="RMUTL mascot" />
            </div>
            <span class="tech-node node-a"><i class="ti ti-qrcode"></i></span>
            <span class="tech-node node-b"><i class="ti ti-school"></i></span>
            <span class="tech-node node-c"><i class="ti ti-bulb"></i></span>
            <span class="tech-node node-d"><i class="ti ti-wifi"></i></span>
          </div>

          <div class="visual-copy">
            <h1>เปิดบ้านราชมงคลล้านนา</h1>
            <p>เปิดประสบการณ์เรียนรู้สายอาชีพและเทคโนโลยี</p>
          </div>
        </section>

        <section class="login-panel">
          <div class="panel-heading">
            <h2>เข้าสู่ระบบรับลงทะเบียน</h2>
          </div>
          <div class="login-field">
            <label for="auth_code">รหัสรับลงทะเบียน</label>
            <div class="input-shell" :class="{ 'has-error': check_auth }">
              <i class="ti ti-id-badge-2"></i>
              <input type="text" v-model="auth_code" id="auth_code" autocomplete="off"
                placeholder="กรอกรหัสรับลงทะเบียน" @keyup.enter="checkinAuth" />
            </div>
            <small class="login-error" v-if="check_auth">
              รหัสรับลงทะเบียนไม่ถูกต้อง
            </small>
          </div>
          <button class="login-submit" @click="checkinAuth" :disabled="auth_code.length == 0 || is_loading">
            <i class="ti ti-arrow-right"></i>
            <span>ยืนยันรหัสรับลงทะเบียน</span>
          </button>
          <div class="login-footer">
            <span>ออกแบบและพัฒนาโดย</span>
            <a href="https://arit.rmutl.ac.th" target="_blank">
              สำนักวิทยบริการและเทคโนโลยีสารสนเทศ
            </a>
          </div>
        </section>
      </div>
    </div>
    <div v-else class="login-shell" :class="{
      'bg-content': $store.state.screenWidth > 375,
      'bg-content-se': $store.state.screenWidth <= 375,
      'bg-content-4': $store.state.screenWidth <= 320
    }">
      <div class="dashboard-layout">
        <div class="dashboard-sidebar">
          <div class="status-card" :class="{ 'is-active': is_focus }">
            <div class="status-icon">
              <div class="radar-ping"></div>
              <i :class="is_focus ? 'ti ti-scan' : 'ti ti-player-pause'"></i>
            </div>
            <div class="status-info">
              <h3>สถานะเครื่องสแกน</h3>
              <p v-if="is_focus" class="text-success">เครื่องสแกนพร้อมทำงาน</p>
              <p v-else class="text-danger">เครื่องสแกนไม่พร้อมทำงาน</p>
            </div>
          </div>

          <div class="stats-card">
            <div class="stats-icon"><i class="ti ti-users"></i></div>
            <div class="stats-info">
              <h3>ลงทะเบียนสำเร็จสะสม</h3>
              <div class="stats-number">{{ successCount }} <span class="stats-unit">คน</span></div>
            </div>
          </div>

          <button class="logout-btn" @click="logout">
            <i class="ti ti-logout"></i>
            <span>ออกจากระบบสแกน</span>
          </button>
        </div>

        <div class="history-panel">
          <div class="history-header">
            <h2>ประวัติการสแกนเช็คอิน</h2>
            <button v-if="history_list.length > 0" class="clear-btn" @click="clearHistory"><i class="ti ti-trash"></i>
              ล้างประวัติ</button>
          </div>
          <div class="history-table-container">
            <table v-if="history_list.length > 0" class="history-table">
              <thead>
                <tr>
                  <th>เวลา</th>
                  <th>ชื่อ-นามสกุล</th>
                  <th>อีเมล</th>
                  <th class="text-end">สถานะการเช็คอิน</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in history_list" :key="index" :class="item.status">
                  <td class="col-time">{{ item.time }}</td>
                  <td class="col-name">{{ item.name }}</td>
                  <td class="col-email">{{ item.email }}</td>
                  <td class="col-status text-end">
                    <span class="status-badge" :class="item.status">
                      <i :class="item.status === 'success' ? 'ti ti-circle-check' : 'ti ti-circle-x'"></i>
                      {{ item.status === 'success' ? 'สำเร็จ' : item.message }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>

            <div v-else class="empty-state">
              <i class="ti ti-qrcode"></i>
              <p>ยังไม่มีประวัติการสแกนเช็คอิน</p>
              <span>ใช้เครื่องสแกนบาร์โค้ด / QR Code เพื่อบันทึกข้อมูลได้ทันที</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderView from './layouts/HeaderView.vue'
import Swal from 'sweetalert2'
import api from '../assets/services'

export default {
  components: {
    HeaderView
  },
  data() {
    return {
      is_loading: false,
      auth_token: '',
      auth_code: '',
      check_auth: false,
      // scanner
      is_focus: false,
      scan_input: '',
      is_english: false,
      history_list: []
    }
  },
  computed: {
    successCount() {
      return this.history_list.filter(item => item.status === 'success').length
    }
  },
  mounted() {
    // auth
    const auth_data_str = localStorage.getItem('auth_data')
    if (auth_data_str) {
      try {
        const auth_data = JSON.parse(auth_data_str)
        const now = new Date().getTime()
        if (auth_data && auth_data.auth_token && auth_data.expiry && now < auth_data.expiry) {
          this.auth_token = auth_data.auth_token
        } else {
          localStorage.removeItem('auth_data')
          this.auth_token = ''
        }
      } catch (e) {
        localStorage.removeItem('auth_data')
        this.auth_token = ''
      }
    } else {
      this.auth_token = ''
    }

    // load scan history
    const storedHistory = localStorage.getItem('checkin_history')
    if (storedHistory) {
      try {
        this.history_list = JSON.parse(storedHistory)
      } catch (e) {
        this.history_list = []
      }
    }
    // scanner
    this._scanBuffer = ''
    this._scanTimeout = null
    this._onKeyDown = e => {
      if (Swal.isVisible()) {
        e.preventDefault()
        e.stopPropagation()
        return
      }
      if (e.type !== 'keydown') return
      const tag = document.activeElement ? document.activeElement.tagName : ''
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || this.auth_token === '') return

      if (e.key === 'Enter') {
        e.preventDefault()
        if (this._scanBuffer.length > 0) {
          this.scan_input = this._scanBuffer
          this._scanBuffer = ''
          clearTimeout(this._scanTimeout)
          this.checkinRegister()
        }
      } else if (e.key.length === 1 || e.key === 'Spacebar') {
        if (e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault()
        }
        let char = e.key === 'Spacebar' ? ' ' : e.key
        if (char.charCodeAt(0) > 127) {
          if (this.is_english) {
            this.is_english = false
            Swal.fire({
              title: 'เกิดข้อผิดพลาด',
              text: 'กรุณาเปลี่ยนคีย์บอร์ดเป็นภาษาอังกฤษ',
              icon: 'error',
              confirmButtonText: 'ปิดหน้านี้',
              focusConfirm: false
            })
          }
          this._scanBuffer = ''
          clearTimeout(this._scanTimeout)
          return
        }
        this.is_english = true
        this._scanBuffer += char
        clearTimeout(this._scanTimeout)
        this._scanTimeout = setTimeout(() => {
          this._scanBuffer = ''
        }, 200)
      }
    }
    document.addEventListener('keydown', this._onKeyDown)
    document.addEventListener('keyup', this._onKeyDown)
    document.addEventListener('keypress', this._onKeyDown)
    this.is_focus = document.hasFocus()
    this._onFocus = () => {
      this.is_focus = true
    }
    this._onBlur = () => {
      this.is_focus = false
    }
    window.addEventListener('focus', this._onFocus)
    window.addEventListener('blur', this._onBlur)
  },
  beforeDestroy() {
    if (this._onKeyDown) {
      document.removeEventListener('keydown', this._onKeyDown)
      document.removeEventListener('keyup', this._onKeyDown)
      document.removeEventListener('keypress', this._onKeyDown)
    }
    if (this._onFocus) {
      window.removeEventListener('focus', this._onFocus)
    }
    if (this._onBlur) {
      window.removeEventListener('blur', this._onBlur)
    }
    clearTimeout(this._scanTimeout)
  },
  methods: {
    checkinAuth() {
      if (this.auth_code.length > 0) {
        this.is_loading = true
        api.checkinAuth(
          this.$store.state.URL,
          { auth_code: this.auth_code },
          this.header,
          result => {
            if (result.status === 'success') {
              const expiry_limit = 24 * 60 * 60 * 1000 // 24 hours
              const auth_data = {
                auth_token: result.auth_token,
                expiry: new Date().getTime() + expiry_limit
              }
              localStorage.setItem('auth_data', JSON.stringify(auth_data))
              this.auth_token = result.auth_token
            } else {
              Swal.fire({
                title: 'เกิดข้อผิดพลาด',
                text: result.message,
                icon: 'error',
                confirmButtonText: 'ปิดหน้านี้'
              })
            }
            this.is_loading = false
          },
          error => {
            console.log(error)
            Swal.fire({
              title: 'เกิดข้อผิดพลาด',
              text: 'ระบบประมวลผลผิดพลาด กรุณาลองใหม่อีกครั้ง',
              icon: 'error',
              confirmButtonText: 'ปิดหน้านี้'
            })
            this.is_loading = false
          }
        )
      }
    },
    checkinRegister() {
      const user_qr_code = this.scan_input
      if (!user_qr_code) {
        return
      }
      this.header.headers['Auth-Token'] = this.auth_token
      api.checkinRegister(
        this.$store.state.URL,
        { user_qr_code: user_qr_code },
        this.header,
        result => {
          const now_time = new Date().toTimeString().split(' ')[0]
          if (result.status === 'success') {
            const scan_item = {
              time: now_time,
              name: result.data.user_fullname,
              email: result.data.user_email,
              status: 'success',
              message: 'สำเร็จ'
            }
            this.history_list.unshift(scan_item)
            localStorage.setItem('checkin_history', JSON.stringify(this.history_list))

            Swal.fire({
              title: 'เช็คอินสำเร็จ',
              html: `<b>คุณ ${result.data.user_fullname}</b><br>ได้เข้าร่วมงานเรียบร้อยแล้ว`,
              icon: 'success',
              timer: 1500,
              showConfirmButton: false
            })
          } else {
            const scan_item = {
              time: now_time,
              name: '-',
              email: '-',
              status: 'error',
              message: 'ไม่สำเร็จ'
            }
            this.history_list.unshift(scan_item)
            localStorage.setItem('checkin_history', JSON.stringify(this.history_list))

            Swal.fire({
              title: 'เกิดข้อผิดพลาด',
              text: result.message,
              icon: 'error',
              confirmButtonText: 'ปิดหน้านี้'
            })
          }
        },
        error => {
          console.log(error)
          const now_time = new Date().toTimeString().split(' ')[0]
          const scan_item = {
            time: now_time,
            name: '-',
            email: '-',
            status: 'error',
            message: 'ระบบประมวลผลผิดพลาด'
          }
          this.history_list.unshift(scan_item)
          localStorage.setItem('checkin_history', JSON.stringify(this.history_list))

          Swal.fire({
            title: 'เกิดข้อผิดพลาด',
            text: 'ระบบประมวลผลผิดพลาด กรุณาลองใหม่อีกครั้ง',
            icon: 'error',
            confirmButtonText: 'ปิดหน้านี้'
          })
        }
      )
      this.scan_input = ''
    },
    logout() {
      Swal.fire({
        title: 'ออกจากระบบ?',
        text: 'คุณต้องการออกจากระบบเครื่องสแกนลงทะเบียนหรือไม่',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#dc3545',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'ออกจากระบบ',
        cancelButtonText: 'ยกเลิก'
      }).then(result => {
        if (result.isConfirmed) {
          localStorage.removeItem('auth_data')
          this.auth_token = ''
        }
      })
    },
    clearHistory() {
      Swal.fire({
        title: 'ล้างประวัติการสแกน?',
        text: 'คุณต้องการล้างประวัติการสแกนทั้งหมดสะสมในเครื่องนี้หรือไม่ (ไม่ลบข้อมูลในเซิร์ฟเวอร์)',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#dc3545',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'ล้างประวัติ',
        cancelButtonText: 'ยกเลิก'
      }).then(result => {
        if (result.isConfirmed) {
          this.history_list = []
          localStorage.removeItem('checkin_history')
        }
      })
    }
  }
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
}

.login-shell {
  background: radial-gradient(circle at top left, rgba(218, 169, 78, 0.22), transparent 30%), linear-gradient(135deg, #fffaf0 0%, #f6efe2 44%, #fffdf8 100%) !important;
  padding: 18px !important;
  border-radius: 0px !important;
}

.login-layout {
  width: min(1180px, calc(100% - 20px));
  min-height: calc(100% - 8px);
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(0, 1.08fr) minmax(320px, 0.92fr);
  gap: 20px;
  align-items: stretch;
}

.login-visual,
.login-panel {
  border: 1px solid rgba(116, 87, 60, 0.12);
  background: rgba(255, 255, 255, 0.84);
  box-shadow: 0 22px 60px rgba(33, 39, 55, 0.13);
  backdrop-filter: blur(14px);
}

.login-visual {
  position: relative;
  min-height: 520px;
  padding: 34px;
  overflow: hidden;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: #1b2936;
}

.login-visual::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(rgba(28, 69, 83, 0.07) 1px, transparent 1px), linear-gradient(90deg, rgba(28, 69, 83, 0.07) 1px, transparent 1px);
  background-size: 34px 34px;
  mask-image: linear-gradient(to bottom, #000, transparent 88%);
}

.login-brand,
.visual-copy,
.tech-orbit {
  position: relative;
  z-index: 1;
}

.login-brand {
  display: inline-flex;
  align-items: center;
  gap: 14px;
}

.login-brand img {
  width: 58px;
  height: 58px;
  object-fit: contain;
}

.login-brand span,
.panel-heading p {
  display: block;
  margin: 0;
  color: #7c654f;
  font-size: 13px;
  letter-spacing: 0;
}

.login-brand strong {
  display: block;
  color: #74573c;
  font-size: 22px;
  font-weight: 600;
}

.tech-orbit {
  width: min(360px, 72vw);
  aspect-ratio: 1;
  margin: 8px auto;
  border: 1px solid rgba(185, 130, 46, 0.28);
  border-radius: 50%;
  display: grid;
  place-items: center;
}

.tech-orbit::before,
.tech-orbit::after {
  content: '';
  position: absolute;
  border: 1px solid rgba(116, 87, 60, 0.16);
  border-radius: 50%;
}

.tech-orbit::before {
  inset: 17%;
}

.tech-orbit::after {
  inset: 31%;
}

.tech-core {
  width: 96px;
  height: 96px;
  border-radius: 28px;
  display: grid;
  place-items: center;
  color: #ffffff;
  background: linear-gradient(135deg, #b9822e, #5a3b25);
  box-shadow: 0 18px 36px rgba(185, 130, 46, 0.28);
  font-size: 44px;
}

.tech-core img {
  width: 88%;
  height: 88%;
  object-fit: contain;
}

.tech-node {
  position: absolute;
  width: 58px;
  height: 58px;
  border-radius: 18px;
  display: grid;
  place-items: center;
  color: #9f6f28;
  background: #ffffff;
  border: 1px solid rgba(185, 130, 46, 0.2);
  box-shadow: 0 14px 30px rgba(33, 39, 55, 0.11);
  font-size: 28px;
}

.node-a {
  top: 12%;
  right: 20%;
}

.node-b {
  left: 10%;
  top: 45%;
  color: #74573c;
}

.node-c {
  right: 9%;
  bottom: 24%;
  color: #b9822e;
}

.node-d {
  left: 33%;
  bottom: 5%;
}

.visual-copy h1 {
  max-width: 520px;
  margin: 0 0 12px;
  color: #18242f;
  font-size: 34px;
  line-height: 1.28;
  font-weight: 600;
}

.visual-copy p {
  max-width: 520px;
  margin: 0;
  color: #7c654f;
  font-size: 16px;
  line-height: 1.7;
}

.login-panel {
  min-height: 520px;
  padding: 36px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.panel-heading {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 30px;
}

.panel-icon {
  flex: 0 0 auto;
  width: 52px;
  height: 52px;
  border-radius: 0;
  display: grid;
  place-items: center;
  color: #ffffff;
  background: transparent;
  font-size: 28px;
}

.panel-icon img {
  width: 42px;
  height: 42px;
  object-fit: contain;
}

.panel-heading h2 {
  margin: 0;
  color: #18242f;
  font-size: 32px;
  font-weight: 600;
}

.login-field {
  margin-bottom: 18px;
}

.login-field label {
  display: block;
  margin-bottom: 10px;
  color: #253443;
  font-size: 15px;
  font-weight: 500;
}

.input-shell {
  display: grid;
  grid-template-columns: 24px minmax(0, 1fr);
  gap: 10px;
  align-items: center;
  min-height: 54px;
  padding: 0 16px;
  border: 1px solid #d4dde1;
  border-radius: 8px;
  background: #ffffff;
  color: #8a714f;
  transition: border-color 0.16s ease, box-shadow 0.16s ease;
}

.input-shell:focus-within {
  border-color: #b9822e;
  box-shadow: 0 0 0 4px rgba(185, 130, 46, 0.16);
}

.input-shell.has-error {
  border-color: #d63939;
  box-shadow: 0 0 0 4px rgba(214, 57, 57, 0.12);
}

.input-shell i {
  font-size: 24px;
}

.input-shell input {
  width: 100%;
  min-width: 0;
  border: 0;
  outline: 0;
  color: #18242f;
  background: transparent;
  font-size: 16px;
}

.input-shell input::placeholder {
  color: #a8957e;
}

.login-error {
  display: block;
  margin-top: 8px;
  color: #d63939;
  font-size: 13px;
}

.login-submit {
  width: 100%;
  min-height: 56px;
  border: 0;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #ffffff;
  background: linear-gradient(135deg, #5a3b25, #b9822e);
  font-size: 20px;
  font-weight: 500;
  box-shadow: 0 16px 28px rgba(116, 87, 60, 0.2);
  transition: transform 0.16s ease, box-shadow 0.16s ease;
}

.login-submit:hover {
  transform: translateY(-1px);
  box-shadow: 0 20px 34px rgba(185, 130, 46, 0.24);
}

.login-submit:active {
  transform: translateY(0);
}

.login-submit i {
  font-size: 24px;
}

.login-footer {
  margin-top: 28px;
  padding-top: 18px;
  border-top: 1px solid rgba(116, 87, 60, 0.12);
  display: grid;
  gap: 6px;
  color: #7c654f;
  font-size: 13px;
  line-height: 1.5;
  text-align: center;
}

.login-footer a {
  color: #9f6f28;
  font-weight: 500;
}

@media (max-width: 991px) {
  .login-shell {
    min-height: calc(100vh - 120px);
    padding: 18px 14px calc(18px + env(safe-area-inset-bottom)) !important;
    display: flex;
    align-items: flex-start;
  }

  .login-visual {
    display: none;
  }

  .login-layout {
    width: min(480px, 100%);
    grid-template-columns: 1fr;
  }

  .login-panel {
    min-height: min(760px, calc(100vh - 156px));
    padding: 148px 26px 42px;
    border: 0;
    border-radius: 28px;
    justify-content: flex-start;
    background: linear-gradient(45deg, transparent 49%, rgba(116, 87, 60, 0.14) 50%, transparent 51%) right 18px top 0 / 220px 220px no-repeat,
      linear-gradient(135deg, transparent 49%, rgba(185, 130, 46, 0.13) 50%, transparent 51%) right -18px top 42px / 240px 240px no-repeat, linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(255, 255, 255, 0.94)), #ffffff;
    box-shadow: 0 22px 52px rgba(76, 50, 31, 0.18);
  }

  .login-panel::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: min(58vw, 280px);
    height: 220px;
    border-top-right-radius: 28px;
    background: linear-gradient(30deg, transparent 44%, rgba(116, 87, 60, 0.16) 45%, rgba(116, 87, 60, 0.16) 46%, transparent 47%) 0 12px / 120px 88px,
      linear-gradient(150deg, transparent 44%, rgba(185, 130, 46, 0.16) 45%, rgba(185, 130, 46, 0.16) 46%, transparent 47%) 56px 0 / 136px 96px, linear-gradient(90deg, transparent 49%, rgba(116, 87, 60, 0.1) 50%, transparent 51%) 120px 40px / 130px 130px;
    opacity: 0.75;
    pointer-events: none;
  }

  .panel-heading {
    position: relative;
    z-index: 1;
    align-items: center;
    margin-bottom: 28px;
  }

  .panel-icon {
    width: 56px;
    height: 56px;
    border-radius: 0;
    color: #8a5d24;
    background: transparent;
    font-size: 46px;
  }

  .panel-icon img {
    width: 56px;
    height: 56px;
  }

  .panel-heading p {
    font-size: 12px;
  }

  .panel-heading h2 {
    font-size: 30px;
  }

  .login-field,
  .login-submit,
  .login-footer {
    position: relative;
    z-index: 1;
  }

  .login-field {
    margin-bottom: 18px;
  }

  .login-field label {
    color: #1f1710;
    font-size: 14px;
  }

  .input-shell {
    min-height: 58px;
    border-color: #2f241b;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.94);
  }

  .login-submit {
    min-height: 60px;
    border-radius: 12px;
  }

  .login-footer {
    margin-top: 32px;
    padding-top: 22px;
  }
}

@media (max-width: 767px) {
  .login-shell {
    padding: 12px 12px calc(20px + env(safe-area-inset-bottom)) !important;
  }

  .login-layout {
    width: 100%;
    gap: 12px;
  }

  .login-visual {
    min-height: 230px;
    padding: 22px;
  }

  .tech-orbit {
    position: absolute;
    right: -72px;
    top: 18px;
    width: 220px;
    opacity: 0.68;
  }

  .tech-core {
    width: 70px;
    height: 70px;
    border-radius: 22px;
    font-size: 34px;
  }

  .tech-node {
    width: 42px;
    height: 42px;
    border-radius: 14px;
    font-size: 22px;
  }

  .visual-copy h1 {
    max-width: 270px;
    font-size: 24px;
  }

  .visual-copy p {
    max-width: 280px;
    font-size: 14px;
  }

  .login-panel {
    min-height: min(760px, calc(100vh - 148px));
    padding: 140px 26px 40px;
  }

  .panel-heading {
    gap: 12px;
    margin-bottom: 22px;
  }

  .panel-heading h2 {
    font-size: 30px;
  }

  .input-shell input {
    font-size: 15px;
  }

  .input-shell input::placeholder {
    font-size: 14px;
  }

  .login-submit {
    font-size: 18px;
  }
}

@media (max-width: 360px) {
  .login-panel {
    min-height: min(720px, calc(100vh - 138px));
    padding: 126px 24px 34px;
  }

  .visual-copy h1 {
    font-size: 21px;
  }

  .panel-heading h2 {
    font-size: 25px;
  }

  .panel-icon {
    width: 50px;
    height: 50px;
    font-size: 40px;
  }

  .panel-icon img {
    width: 50px;
    height: 50px;
  }

  .login-field label,
  .login-footer {
    font-size: 12px;
  }

  .input-shell input {
    font-size: 14px;
  }
}

/* Dashboard Layout */
.dashboard-layout {
  display: grid;
  grid-template-columns: 320px 1fr;
  gap: 24px;
  width: min(1200px, 100%);
  margin: 0 auto;
  align-items: start;
}

@media (max-width: 991px) {
  .dashboard-layout {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}

/* Dashboard Sidebar / Stats */
.dashboard-sidebar {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Glassmorphic Cards */
.status-card,
.stats-card,
.history-panel {
  background: rgba(255, 255, 255, 0.85);
  border: 1px solid rgba(116, 87, 60, 0.12);
  border-radius: 16px;
  box-shadow: 0 15px 35px rgba(76, 50, 31, 0.08);
  backdrop-filter: blur(14px);
  padding: 24px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.status-card:hover,
.stats-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 18px 40px rgba(76, 50, 31, 0.12);
}

/* Status Card Indicator */
.status-card {
  display: flex;
  align-items: center;
  gap: 18px;
}

.status-icon {
  position: relative;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: rgba(226, 160, 72, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #e2a048;
}

.status-card.is-active .status-icon {
  background: rgba(46, 196, 182, 0.1);
  color: #2ec4b6;
}

/* Radar Ping animation */
.radar-ping {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: currentColor;
  opacity: 0.15;
  animation: ping 2s cubic-bezier(0, 0, 0.2, 1) infinite;
}

@keyframes ping {

  75%,
  100% {
    transform: scale(1.6);
    opacity: 0;
  }
}

.status-info h3,
.stats-info h3 {
  margin: 0 0 6px 0;
  font-size: 15px;
  color: #7c654f;
  font-weight: 500;
}

.status-info p {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
}

.text-success {
  color: #2ec4b6 !important;
}

.text-warning {
  color: #e2a048 !important;
}

/* Stats Card */
.stats-card {
  display: flex;
  align-items: center;
  gap: 18px;
}

.stats-icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: rgba(116, 87, 60, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #74573c;
}

.stats-number {
  font-size: 32px;
  font-weight: 700;
  color: #1b2936;
  line-height: 1.1;
}

.stats-unit {
  font-size: 16px;
  font-weight: 500;
  color: #7c654f;
  margin-left: 4px;
}

/* Logout Button */
.logout-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 16px;
  background: #ffffff;
  border: 1px solid rgba(197, 51, 51, 0.2);
  border-radius: 12px;
  color: #c53333;
  font-weight: 600;
  font-size: 15px;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(197, 51, 51, 0.05);
  transition: all 0.2s ease;
}

.logout-btn:hover {
  background: #fff5f5;
  border-color: #c53333;
  box-shadow: 0 6px 15px rgba(197, 51, 51, 0.1);
}

/* History Panel */
.history-panel {
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-height: 400px;
}

.history-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(116, 87, 60, 0.08);
  padding-bottom: 14px;
}

.history-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #74573c;
  display: flex;
  align-items: center;
  gap: 8px;
}

.clear-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: none;
  color: #7c654f;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  padding: 6px 12px;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.clear-btn:hover {
  background: rgba(116, 87, 60, 0.08);
  color: #74573c;
}

/* History Table */
.history-table-container {
  overflow-x: auto;
  flex-grow: 1;
}

.history-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  font-size: 15px;
}

.history-table th {
  padding: 12px 16px;
  color: #7c654f;
  font-weight: 500;
  border-bottom: 2px solid rgba(116, 87, 60, 0.1);
}

.history-table td {
  padding: 14px 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
  color: #1b2936;
}

.history-table tr.success {
  background: rgba(46, 196, 182, 0.02);
}

.history-table tr.error {
  background: rgba(197, 51, 51, 0.02);
}

.col-time {
  font-weight: 600;
  color: #7c654f !important;
  white-space: nowrap;
}

.col-code code {
  background: rgba(0, 0, 0, 0.05);
  padding: 3px 8px;
  border-radius: 4px;
  font-family: monospace;
  font-size: 13px;
}

.col-name {
  font-weight: 500;
}

.col-email {
  color: #7c654f;
}

/* Status Badges */
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
}

.status-badge.success {
  background: rgba(46, 196, 182, 0.12);
  color: #1ba396;
}

.status-badge.error {
  background: rgba(197, 51, 51, 0.12);
  color: #a72828;
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Empty State */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
  color: #7c654f;
}

.empty-state i {
  font-size: 64px;
  margin-bottom: 16px;
  opacity: 0.4;
  color: #74573c;
}

.empty-state p {
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 6px 0;
  color: #74573c;
}

.empty-state span {
  font-size: 14px;
  opacity: 0.8;
}
</style>



// WEBPACK FOOTER //
// src/components/Checkin.vue